export default {
  brand: {
    leninka: "Leninka",
    artIp: "Art IP",
    digitalEnv: "digital environment of the Leninka Art project",
    digitalEnvShort: "digital environment of the Leninka Art project",
  },
  nav: {
    home: "Home",
    profile: "Profile",
    events: "Events",
    projects: "Projects",
    deposit: "Deposit",
    admin: "Administration",
    contacts: "Contacts",
    about: "About",
    login: "Sign in",
    loginMobile: "Sign in / Profile",
    logout: "Sign out",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    partnersGroup: "Partner logos",
    partnerAilaAlt: "AILA logo",
    partnerLeninkaArtAlt: "Leninka Art project logo",
    eventsMenuAria: "Events section menu",
    eventsMenuPanelHeading: "Schedule and event management",
    eventsMenu: {
      all: "All events",
      created: "My events",
      moderation: "Event moderation",
      registrations: "Participant moderation",
    },
    projectsMenuAria: "Projects section menu",
    projectsMenuPanelHeading: "Projects and accelerator",
    projectsMenu: {
      all: "All projects",
      portal: "Projects Portal",
    },
  },
  footer: {
    portalTitle: "Ecosystem",
    infoTitle: "Information",
    aboutLibrary: "About us",
    contacts: "Contacts",
    personalDataConsent: "Consent to personal data processing",
    personalDataProcessingPolicy: "Personal data processing policy",
    tagline:
      "We help authors develop ideas, find like-minded people, and build an individual professional growth path.",
    copyright: "\u00a9 2026 Leninka Art IP. All rights reserved.",
    terms: "Terms of use",
    socialVk: "VK",
    socialTelegram: "Telegram",
  },
  common: {
    all: "All",
    more: "Learn more",
    openLink: "Open",
    register: "Register",
    close: "Close",
    cancel: "Cancel",
    searchCatalog: "Search the catalogue...",
    charLimit: "Character limit exceeded",
    or: "or",
    loading: "Loading...",
    opensInNewTab: "opens in a new tab",
    skipToContent: "Skip to content",
    pager: {
      navigation: "Pagination",
      previousPage: "Previous page",
      nextPage: "Next page",
    },
    datePicker: {
      prevMonth: "Previous month",
      nextMonth: "Next month",
      clearDate: "Clear date",
      selectDay: "Day",
      selectMonth: "Month",
      selectYear: "Year",
      selectPlaceholder: "—",
      calendarBirth: "Choose date of birth",
      calendarAchievement: "Choose achievement date",
      calendarWorkCreation: "Choose work creation date",
    },
    timePicker: {
      hours: "Hours",
      minutes: "Minutes",
    },
    table: {
      sortAria: "Sort: {{column}}, {{direction}}",
      sortDirectionAsc: "ascending",
      sortDirectionDesc: "descending",
      sortDirectionNone: "unsorted",
    },
  },
  breadcrumbs: {
    home: "Home",
    events: "Events",
    projects: "Projects",
    deposits: "Deposit",
    details: "Details",
  },
  home: {
    hero: {
      badge: "Leninka",
      badgeAccent: "Art IP",
      titleLine1: "Knowledge.",
      titleLine2: "Creativity.",
      titleLine3: "The future.",
      subtitle:
        "We help authors develop ideas, find like-minded people, and build an individual professional growth path.",
      quickEvents: "Events",
      quickDeposit: "Deposit",
      quickProjects: "Projects",
      statProjects: "projects",
      statYear: "founded",
      statReaders: "readers",
      imageAlt: "Lenin Library",
      scrollToQuickLinks: "Go to quick links",
    },
    directions: {
      kicker: "What we offer",
      title1: "MAIN",
      title2: "FOCUS AREAS",
      eventsTitle: "Events",
      eventsDesc:
        "Conferences, lectures, exhibitions, workshops, and hackathons. Take part and organise events.",
      projectsTitle: "Projects",
      projectsDesc:
        "Create research and creative projects, get community feedback and expert support.",
      depositTitle: "Deposit",
      depositDesc:
        "Official registration and protection of copyright for your works in the RSL collections.",
    },
    events: {
      kicker: "What\u2019s on",
      title: "Events",
      allLink: "All events",
      empty: "No upcoming events right now",
    },
    projects: {
      kicker: "Deposit",
      title: "Public register",
      allLink: "All entries",
    },
    cta: {
      titleLine1: "Join the",
      titleLine2: "RSL community",
      subtitle:
        "Sign up to take part in events, create projects, and grow with the RSL community.",
      register: "Register",
      imageAlt: "Join us",
    },
  },
  aboutPage: {
    documentTitle: "About us \u2014 Leninka Art IP",
    kicker: "Ecosystem",
    title: "About us",
    lead:
      "Leninka Art IP is the digital platform of the Leninka Art ecosystem, created by ANO Leninka Art with the support of the Russian State Library. Here creators, researchers, and creative teams find events, launch projects, and build skills at the intersection of culture and technology.",
    childSiteTitle: "What is Leninka Art IP",
    childSiteBody1:
      "The portal was built for convenient online work: event registration, accelerator project submissions, and engaging with a professional community. It complements the offline programmes of the Leninka Art creative residency in the historic building at Mokhovaya 12 and RSL services by moving key processes into digital.",
    missionTitle: "Mission",
    missionText: "We develop the space of the future and a core of expertise in digital solutions for culture.",
    valuesTitle: "Values",
    values: {
      elite: "Building an intellectual elite",
      trends: "Exploring trends",
      environment: "Creating an environment for future professionals",
    },
    orgTeamTitle: "ANO Leninka Art team",
    orgTeamIntro:
      "The team includes leaders and specialists responsible for strategy, programme activities, legal support, media, digital service architecture, and data management.",
    team: {
      director: "Anna Afanasyeva \u2014 CEO",
      exec: "Lyudmila Aliyeva \u2014 executive director",
      program: "Matvey Navdayev \u2014 programme director",
      accountant: "Lyudmila Kovalenko \u2014 chief accountant",
      legal: "Sergey Taranov \u2014 chief legal counsel",
      neurofest: "Olga Miloserdova \u2014 head of Neurofest project",
      media: "Ksenia Uzunova \u2014 head of media",
      digital: "Roman Ilyin \u2014 digital services architect",
      data: "Victoria Arabina \u2014 data lake architect",
    },
    orgTeamCta: "Full team on leninkaart.ru",
    expertCouncilTitle: "Expert council",
    expertCouncilIntro:
      "ANO Leninka Art has an expert council that brings together leaders from AI, banking, telecom, culture, and science. The council helps shape the project strategy and ensures a strong connection with industry.",
    experts: {
      kraynov: {
        name: "Alexander Kraynov",
        role: "Director of AI Technology Development, Yandex",
      },
      dimitrov: {
        name: "Denis Dimitrov",
        role: "Managing Director of Data Research, Sber AI",
      },
      vorobeva: {
        name: "Valeria Vorobyova",
        role: "CEO of the AI Alliance",
      },
      mashkovtsev: {
        name: "Boris Mashkovtsev",
        role: "CEO of Soyuzmultfilm",
      },
      voloshin: {
        name: "Stanislav Voloshin",
        role: "Deputy Chairman of the Board, Skolkovo Foundation",
      },
      shubin: {
        name: "Mikhail Shubin",
        role: "Deputy Director General \u2014 Chief Digital Officer, RSL",
      },
      markov: {
        name: "Dmitry Markov",
        role: "Executive Director of MTS AI, CEO of VisionLabs",
      },
      vaganov: {
        name: "Daniil Vaganov",
        role: "Head of ML Department, Positive Technologies",
      },
    },
    expertCouncilMore:
      "The council also includes representatives from VTB, Alfa-Bank, Dom.RF, Rosatom, MARHI, Tretyakov Gallery, Cosmoscow, and other organisations. The full list and bios are on the official page.",
    expertCouncilCta: "Full expert council list on leninkaart.ru",
    ctaContacts: "Write to us",
  },
  contactsPage: {
    kicker: "Contact us",
    title: "Contacts",
    writeUs: "Write to us",
    sentTitle: "Message sent!",
    sentHint: "We will reply within 1\u20132 business days.",
    name: "Name",
    email: "Email",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    address: "Address",
    phone: "Phone",
    emailBlock: "Email",
    officialPages: "Official pages",
    siteLabel: "LeninkaArt NGO website",
    socialNetworks: "Social networks",
    mapTitle: "RSL map",
    subjects: {
      general: "General question",
      events: "Events",
      deposit: "Deposit",
      tech: "Technical support",
      coop: "Partnership",
    },
  },
  legalPages: {
    agreementTitle: "User agreement \u2014 Leninka Art IP",
    personalTitle: "Consent to personal data processing \u2014 Leninka Art IP",
    privacyTitle: "Personal data processing policy \u2014 Leninka Art IP",
    projectConsentStubs: {
      personalData: {
        title: "Personal data processing consent (project) \u2014 Leninka Art IP",
        body: "The full text of this document is being prepared and will be published later. You can continue filling out your application.",
      },
      ipRights: {
        title: "Consent to transfer of intellectual property rights (project) \u2014 Leninka Art IP",
        body: "The full text of this document is being prepared and will be published later. You can continue filling out your application.",
      },
      documentsReadiness: {
        title: "Confirmation of document readiness (project) \u2014 Leninka Art IP",
        body: "The full text of this document is being prepared and will be published later. You can continue filling out your application.",
      },
      photoVideo: {
        title: "Consent to photo and video recording (project) \u2014 Leninka Art IP",
        body: "The full text of this document is being prepared and will be published later. You can continue filling out your application.",
      },
    },
  },
  notFound: {
    title: "Page not found",
    hint: "Check the URL or return to the home page.",
    backHome: "Back to home",
  },
}
